__turbopack_context__.v({
  "base": "Input-module-scss-module__gIf6KW__base",
  "error": "Input-module-scss-module__gIf6KW__error",
  "filled": "Input-module-scss-module__gIf6KW__filled",
  "floating": "Input-module-scss-module__gIf6KW__floating",
  "focused": "Input-module-scss-module__gIf6KW__focused",
  "hasChildren": "Input-module-scss-module__gIf6KW__hasChildren",
  "input": "Input-module-scss-module__gIf6KW__input",
  "inputLabel": "Input-module-scss-module__gIf6KW__inputLabel",
  "label": "Input-module-scss-module__gIf6KW__label",
  "labelAsPlaceholder": "Input-module-scss-module__gIf6KW__labelAsPlaceholder",
  "m": "Input-module-scss-module__gIf6KW__m",
  "prefix": "Input-module-scss-module__gIf6KW__prefix",
  "s": "Input-module-scss-module__gIf6KW__s",
  "suffix": "Input-module-scss-module__gIf6KW__suffix",
  "textareaBase": "Input-module-scss-module__gIf6KW__textareaBase",
  "textareaLabel": "Input-module-scss-module__gIf6KW__textareaLabel",
});
